// Global CRT overlay: scanlines, vignette, faint green phosphor tint, gentle
// flicker, and a one-shot power-on scan on first visit per browser session.
// All layers are pointer-events: none and marked aria-hidden.
import { useEffect, useState } from 'react';

export default function CRTOverlay() {
  const [showPowerOn, setShowPowerOn] = useState(() => {
    if (typeof window === 'undefined') return false;
    try {
      return !window.sessionStorage.getItem('logos:crt:powered');
    } catch (_) {
      return false;
    }
  });

  useEffect(() => {
    if (!showPowerOn) return;
    try {
      window.sessionStorage.setItem('logos:crt:powered', '1');
    } catch (_) {
      /* ignore */
    }
    const t = setTimeout(() => setShowPowerOn(false), 1100);
    return () => clearTimeout(t);
  }, [showPowerOn]);

  return (
    <>
      {showPowerOn && <div className="crt-power-on" aria-hidden="true" data-testid="crt-power-on" />}
      <div className="crt-phosphor" aria-hidden="true" data-testid="crt-phosphor" />
      <div className="crt-vignette" aria-hidden="true" data-testid="crt-vignette" />
      <div className="crt-scanlines" aria-hidden="true" data-testid="crt-scanlines" />
      <div className="crt-hum" aria-hidden="true" data-testid="crt-hum" />
    </>
  );
}
